import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {CustomersAlerts} from "../../../customers/services/customers-alerts.service";
import {CustomersDialogService} from "../../../customers/services/customers-dialogs-service.service";
import {CustomersRequests} from "../../../customers/services/customers-requests.service";

export class taskSpecCustomersFormCtrl implements IController {

  form: any;
  taskSpec: any;
  customer: any;
  accountId: any;
  onClick: Function;
  onAddressChange: Function;

  private customerAddressId: any;

  /* @ngInject */
  constructor(private customersDialogService: CustomersDialogService, private $log, private customersRequests: CustomersRequests, private bringozLoaderService: BringozLoaderService,
              private customersAlerts: CustomersAlerts) {
  }

  // ******************************
  //        Public methods
  // ******************************

  onSelectCustomer(customer) {
    this.customer = customer;
    this.customerAddressId = _.get(customer, 'defaultAddressId');
    this.taskSpec.customerId = _.get(customer, 'id');
    this.taskSpec.contact.name = this._getCustomerName(customer);
    this.taskSpec.contact.businessName = _.get(customer, 'businessName');
    this.taskSpec.contact.phoneNo = _.get(customer, 'phone');
    this.taskSpec.contact.email = _.get(customer, 'email');

    if (customer) {
      this.onCustomerAddressIdSelect(customer.defaultAddressId);
    }
  }

  onSearchCustomerChange(searchText) {
    const customerName = this._getCustomerName(this.customer);

    if (!searchText || customerName !== searchText) {
      this.taskSpec.customerId = undefined;
      this.taskSpec.contact.name = searchText;
      this.customer = undefined;
    }
  }

  changeAddress(address) {
    this.taskSpec.address = address;
    this.onAddressChange({address: address});
  }

  onPhoneChange(phone) {
    this.taskSpec.contact.phoneNo = phone;
  }

  _getCustomerName(customer) {
    if (!customer) {
      return undefined;
    }
    return _.get(customer, 'firstName', '') + ' ' + _.get(customer, 'lastName', '');
  }

  onCustomerAddressIdSelect(addressId) {
    this.customerAddressId = addressId;
    const address = angular.copy(_.find(this.customer.addresses, (a) => {
      return a.id === addressId;
    }));
    if (address) {
      this.changeAddress(address);
    }
  }

  onCreateCustomer(customer, event) {
    this.customersDialogService.createCustomer(event, customer)
      .then((customerToCreate) => {
        this._createCustomer(customerToCreate);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onEditCustomer(event) {
    this.customersDialogService.editCustomer(event, this.customer)
      .then((customerToUpdate) => {
        this._updateCustomer(customerToUpdate);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onCreateCustomerAddress(event) {
    this.customersDialogService.addAddress(event)
      .then((address) => {
        this._createCustomerAddress(address);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onEditCustomerAddress(customerAddressId, event) {
    const address = _.find(this.customer.addresses, (address) => {
      return address.id === customerAddressId;
    });

    const originalAddress = angular.copy(address);

    this.customersDialogService.editAddress(address, event)
      .then((editedAddress) => {
        this._updateCustomerAddress(editedAddress, address.id, originalAddress)
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  // ******************************
  //        Private methods
  // ******************************

  _createCustomer(customer) {
    this.bringozLoaderService.on();
    this.customersRequests.createCustomer(customer)
      .then((createdCustomer) => {
        this.onSelectCustomer(createdCustomer);
        this.customersAlerts.createSuccess();
      })
      .catch((error) => {
        this.customersAlerts.createError();
        this.$log.info('Failed to create customer', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  _updateCustomer(customer) {
    this.bringozLoaderService.on();
    this.customersRequests.updateCustomer(customer.id, customer)
      .then((updatedCustomer) => {
        this.onSelectCustomer(updatedCustomer);
        this.customersAlerts.updateSuccess();
      })
      .catch((error) => {
        this.customersAlerts.updateError();
        this.$log.info('Failed to update customer', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  _createCustomerAddress(address) {
    this.bringozLoaderService.on();
    this.customersRequests.addAddress(this.customer.id, address)
      .then((createdAddress) => {
        this.customer.addresses.push(createdAddress);
        this.changeAddress(createdAddress);
        this.customerAddressId = createdAddress.id;
        this.customersAlerts.addAddressSuccess();
      })
      .catch((error) => {
        this.customersAlerts.addAddressError();
        this.$log.info('Failed to update customer', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  _updateCustomerAddress(address, addressId, originalAddress) {
    this.bringozLoaderService.on();
    this.customersRequests.updateAddress(this.customer.id, addressId, address)
      .then((updatedAddress) => {
        this.customer.addresses = _.chain(this.customer.addresses)
          .filter((a) => {
            return a.id !== addressId;
          })
          .concat([updatedAddress])
          .value();

        this.changeAddress(updatedAddress);

        this.customersAlerts.updateAddressSuccess(originalAddress);
      })
      .catch((error) => {
        this.customersAlerts.updateAddressError();
        this.$log.info('Failed to update customer', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

}

angular
  .module('bringoz.admin.tasks')
  .component('taskSpecCustomersForm', {
    require: {
      form: '^form'
    },
    bindings: {
      taskSpec: '<',
      customer: '<',
      accountId: '<?',
      onClick: '&',
      onAddressChange: '&'
    },
    template: require('./task-spec-customers-form.html').default,
    controller: taskSpecCustomersFormCtrl
  });
